<template>
    <BlockUI class="line">
        <div class="new-loading">
        <span></span>
        <span></span>
        <span></span>
        </div>
    </BlockUI>
</template>
  
<script>
export default {
    async mounted() {
        const liffstate =  await this.getLiffStateValue()
        const liffIdQuery = liffstate.liffId ? liffstate.liffId : this.$route.query.liffId
        const liffqueryParam = liffstate.queryparams ? liffstate.queryparams : ''

        let queryParams = ''
        if(this.$route.query.queryparams) {
            console.log(this.$route.query.queryparams)
            queryParams = this.$route.query.queryparams
            console.log('newParam: ' ,queryParams)
        }
        
        // https://liff.line.me/1657832585-rRe2YnZY?liffId=1657832585-rRe2YnZY&redirectPath=registerPOP&queryparams=%3Fparam1%3D0937867607%5Bspace%5Dparam2%3D3000%5Bspace%5Dparam3%3D4000asdasdasd

        let destinationUrl
        let pathRedirect
        if(this.$route.query.redirectPath === 'registerPOP'){
            pathRedirect = '/action/register' + queryParams
        }else if (this.$route.query.redirectPath === 'registerpage') {
            pathRedirect = '/registerpage' + queryParams
        }else if (this.$route.query.redirectPath === 'editConsign') {
            pathRedirect = '/edit/consign' + queryParams
        }else if (this.$route.query.redirectPath === 'cancelorder') {
            pathRedirect = '/cancel/order' + queryParams
        }else if (this.$route.query.redirectPath === 'receipt'){
            pathRedirect = '/receipt' + queryParams
        }else if (this.$route.query.redirectPath === 'paymentOrder') {
            pathRedirect = '/payment/amount' + queryParams
        }else if (this.$route.query.redirectPath === 'showsenders') {
            pathRedirect = '/show/senders' + queryParams
        }else if (this.$route.query.redirectPath === 'editSender' || this.$route.query.redirectPath === 'addSender') {
            pathRedirect = '/manage/sender' + queryParams
        }else if (this.$route.query.redirectPath === 'booksender') {
            pathRedirect = '/book/sender' + queryParams
        }

        destinationUrl = this.$domain+'/line' + '?liffId='+`${liffIdQuery}&redirectPath=${this.$route.query.redirectPath}&queryparams=${liffqueryParam}`;

        await this.$liff.init({ liffId: liffIdQuery }).then(() => {
            if(this.$liff.isInClient()) {
                // running on mobile
                this.isLoginGetLocalStorage(pathRedirect)
            }else {
                // running on desktop
                if(!this.$liff.isLoggedIn()) {
                    this.$liff.login({ redirectUri: destinationUrl })
                }
                this.$liff.ready.then(()=> {
                    this.isLoginGetLocalStorage(pathRedirect)
                })
            }
        })

    },
    methods: {
        getLiffStateValue () {
            const url = new URL(window.location.href);
            const liffState = url.searchParams.get("liff.state");
            const urlParams = new URLSearchParams(liffState);
            const liffId = urlParams.get('liffId');
            const redirectPath = urlParams.get('redirectPath');
            const queryparams = urlParams.get('queryparams');
            const keyObj = { liffId, redirectPath, queryparams }
            return keyObj;
        },
        async isLoginGetLocalStorage(pathRedirect) {
            if(this.$liff.isLoggedIn()) {
                const context = this.$liff.getContext()
                const liffToken = this.$liff.getAccessToken()
                const decodeIDTokenProfile = this.$liff.getDecodedIDToken()
                
                if(!['registerPOP', 'registerpage'].includes(this.$route.query.redirectPath)) {
                    await this.$http.post(this.$API_URL + '/line/login/token', {},
                    {
                        headers: {
                            Token: liffToken
                        },
                    }).then( response => {
                        if(response.data.status){
                            localStorage.setItem('access_token_customer', response.data.data.token)
                        }
                    })        
                }
                localStorage.setItem('profile_line', JSON.stringify(decodeIDTokenProfile))
                localStorage.setItem('context_line', JSON.stringify(context))
                localStorage.setItem('access_token_line', liffToken)
                const urlAction = this.$domain +'/line'+ pathRedirect
                window.location.href = urlAction     
            }
        }
    }
}
</script>

//https://medium.com/@bactrann/development-liff-app-using-nuxtjs-4586e144e31a 
(แนวทาง)
